import ModalService from "services/modal";

export const EDIT_BASIC_INFO_MODULE = "workspace-basic-info";
export const EDIT_CLUSTERS_MODULE = "workspace-clusters";
export const EDIT_NAMESPACES_MODULE = "workspace-namespaces";
export const EDIT_CONTAINER_IMAGES_MODULE = "workspace-container-images";
export const WORKSPACE_NAMESPACE_FORM_MODULE = "workspace-namespace-form";

export const clusterRoleBindingsModal = new ModalService();
export const namespaceRoleBindingsModal = new ModalService();
export const workspaceNamespaceModal = new ModalService();
